import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import IframeWeb from './IframeWeb'


const About = () => {
    const [message, setMessage] = useState('');
    const navigate = useNavigate()

    function launchChat(){
        navigate('/chat')
    }
    return (
        // <div className='wrapper' style={{ marginTop: '6.5rem' }}>
        //     <IframeWeb height="750" source="https://trampolinehealth.circle.so/home" />
        // </div>
        <div className='wrapper' style={{ marginTop: '6.5rem', marginLeft: '1.5rem', marginRight:' 1.5rem' }}>
            <div>
                <h2 className="text-center"> Get Your Data To <br></br> Work For You </h2>
            </div>
            <div className="container" style={{ marginTop: '2rem'}}>
                <div className="item" style={{ padding: '0' }}>
                    <h5> About </h5>
                    <div className="homeBttnContainer" style={{ display:'flex', flexDirection:'column', marginTop:"2.5rem" }}>
                        <button className="homeBttn" onClick={() => {navigate('/in-development')}}>Learn More</button>
                        <button className="homeBttn"  style={{ marginTop:'1rem'}} onClick={() => {navigate('/in-development')}}  >Terms of Service</button>
                        <button className="homeBttn" style={{ marginTop:'1rem'}} onClick={() =>{navigate('/in-development')}}>Privacy Policy</button>
                    </div>

                        {/* <div className="form-group"><label> Send a message: </label><br /> <input type="text" placeholder='question you have' value={message} onChange={event => setMessage(event.target.value)} /> <br /></div>
                        <div className="form-group"><input class="submit-bttn" type="submit" value="Submit" /><br /></div> */}
                </div>
            </div>
        </div>
)
}


export default About;